import React, { useState } from "react";
import CustomDropdown from "../../common/CustomDropdown";

const AgencyPitchesMobileSearchSort = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
}) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  if (isSearchVisible) {
    return (
      <div className="px-4 py-3 bg-white flex items-center gap-2 border-y border-[#0000001A]">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search by player or club"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-8 pr-4 py-2 border border-[#E6E6E6] placeholder:text-sm placeholder:text-[#1E1E1E] rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
            autoFocus
          />
        </div>
        <button
          onClick={() => setIsSearchVisible(false)}
          className="p-2"
          aria-label="Close search"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#1A212F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  }

  return (
    <div className="px-4 py-3 bg-white flex justify-between items-center border-y border-[#0000001A]">
      <div className="flex items-center gap-2 w-full justify-between">
        <div className="text-xs">
          <CustomDropdown
            options={[
              { value: "latest", label: "Latest" },
              { value: "oldest", label: "Oldest" },
            ]}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Latest"
            className="flex items-center gap-2 p-3 bg-[#E9F3FF] text-[#2283FF] rounded-lg font-medium"
          />
        </div>

        <button
          className="p-3 bg-[#F7F7F7] rounded-lg"
          onClick={() => setIsSearchVisible(true)}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
              stroke="#1A212F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AgencyPitchesMobileSearchSort;
